import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
    page: {
        padding: 30,
        backgroundColor: '#ffffff'
    },
    header: {
        marginBottom: 20,
        borderBottomWidth: 1,
        borderBottomColor: '#cccccc',
        paddingBottom: 10,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    title: {
        fontSize: 24,
        color: '#2c3e50',
        fontWeight: 'bold'
    },
    subtitle: {
        fontSize: 10,
        color: '#7f8c8d',
        marginTop: 5
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    sectionTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 10,
        marginTop: 20,
        color: '#2980b9',
        borderBottom: '1px solid #eee',
        paddingBottom: 5
    },
    statsRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 15
    },
    statBox: {
        width: '48%',
        padding: 10,
        backgroundColor: '#f8f9fa',
        borderRadius: 5
    },
    statLabel: {
        fontSize: 10,
        color: '#7f8c8d'
    },
    statValue: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#2c3e50'
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginTop: 10
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableColHeader: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: '#f2f2f2'
    },
    tableCol: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCellHeader: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10,
        fontWeight: 'bold'
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10
    }
});

const ReportsPDF = ({ financial, member, trainer, dateRange }) => {

    const dateStr = dateRange[0] && dateRange[1] 
        ? `${dateRange[0].format('YYYY-MM-DD')} to ${dateRange[1].format('YYYY-MM-DD')}`
        : 'All Time Report';

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <View>
                        <Text style={styles.title}>Gym System Report</Text>
                        <Text style={styles.subtitle}>Generated on: {moment().format('YYYY-MM-DD HH:mm:ss')}</Text>
                        <Text style={styles.subtitle}>Period: {dateStr}</Text>
                    </View>
                </View>

                {/* Financial Section */}
                {financial && (
                    <View>
                        <Text style={styles.sectionTitle}>Financial Overview</Text>
                        <View style={styles.statsRow}>
                            <View style={styles.statBox}>
                                <Text style={styles.statLabel}>Total Revenue</Text>
                                <Text style={styles.statValue}>${financial.totalRevenue}</Text>
                            </View>
                            <View style={styles.statBox}>
                                <Text style={styles.statLabel}>Total Invoices</Text>
                                <Text style={styles.statValue}>{financial.totalInvoices}</Text>
                            </View>
                        </View>
                        
                        <Text style={{fontSize: 12, marginTop: 10, marginBottom: 5}}>Revenue Trend (Last 6 Months/Periods)</Text>
                         <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Month</Text></View>
                                <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Revenue</Text></View>
                            </View>
                            {financial.monthlyRevenue.map((item, index) => (
                                <View style={styles.tableRow} key={index}>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.month}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>${item.total}</Text></View>
                                </View>
                            ))}
                        </View>
                    </View>
                )}

                {/* Member Section */}
                {member && (
                    <View>
                        <Text style={styles.sectionTitle}>Member Analytics</Text>
                        <View style={styles.statsRow}>
                            <View style={styles.statBox}>
                                <Text style={styles.statLabel}>Total Members</Text>
                                <Text style={styles.statValue}>{member.totalMembers}</Text>
                            </View>
                            <View style={styles.statBox}>
                                <Text style={styles.statLabel}>Active Members</Text>
                                <Text style={styles.statValue}>{member.statusDistribution.active}</Text>
                            </View>
                        </View>
                    </View>
                )}
                
                {/* Trainer Section */}
                 {trainer && (
                    <View>
                        <Text style={styles.sectionTitle}>Trainer Overview</Text>
                        <View style={styles.statsRow}>
                             <View style={styles.statBox}>
                                <Text style={styles.statLabel}>Total Trainers</Text>
                                <Text style={styles.statValue}>{trainer.totalTrainers}</Text>
                            </View>
                        </View>

                         <Text style={{fontSize: 12, marginTop: 10, marginBottom: 5}}>Top Trainers by Workload</Text>
                         <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Trainer Name</Text></View>
                                <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Assigned Members</Text></View>
                            </View>
                            {trainer.topTrainers.map((item, index) => (
                                <View style={styles.tableRow} key={index}>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.name}</Text></View>
                                    <View style={styles.tableCol}><Text style={styles.tableCell}>{item.count}</Text></View>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
            </Page>
        </Document>
    );
};

export default ReportsPDF;
